// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'Arial Rounded MT, sans-serif',
    },
});

export default theme;
